export const riskManagementGettingStartedArticle = {
  title: 'Risk Management Command Center: Getting Started',
  slug: 'risk-management-getting-started',
  content: `Risk Management Command Center: Getting Started

Track operational risks and mitigation plans.

1) Open Risk Manager
- Go to /finance/risk-manager.

2) Create a risk profile
- Click “Add Risk” to open the form.
- Add title, source, level, impact, probability, and mitigation plan.

3) Review risk summary
- The summary cards highlight overall exposure.

4) Filter and sort
- Use Filters to narrow by source, level, status, or risk score.

5) Update mitigation
- Edit profiles as plans change and mark status.
`,
};
